<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>买手图文管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div class="screen_wrap flex-rowr">
            <div
              v-for="(item, index) in orderStateList"
              :key="index"
              class="txt"
              :class="params.checkstate == item.value ? 'active' : ''"
              @click="handleState(1, item.value)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示图文列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
        id="table"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div
                class="content_wrap flex-between"
                @click="handleDetail(item.id)"
                
              >
                <div class="pic_box">
                  <el-image :src="item.at_pic" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl" >
                  <div class="block">
                    <p>
                      图文标题：<span>{{ item.at_topic }}</span>
                    </p>
                    <p>
                      图文简介：<span>{{ item.at_intro }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      审核状态：<span>{{ item.checkstatestr }}</span>
                    </p>
                    <p>
                      创建时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="editBtn" @click="handleEdit(item.id)">
                买手图文设置→
              </div> -->
            </div>
          </div>
        </template>
        <el-empty
          description="暂无图文数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringadd } from "../../api/api";
import { getArticleList } from "../../api/article";
import { mapState } from "vuex";
export default {
  name: "articleList",
  data() {
    return {
      listTotal: 0,
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        openid: "",
        checkstate: "",
        qyguid: ''
      },
      // 订单状态
      orderStateList: [
        { text: "全部", value: "" },
        { text: "待审核", value: "待审核" },
        { text: "已审核", value: "已审核" },
      ],
      loading: false,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.params.qyguid = userInfo.qy ? userInfo.qy.qyguid : "";
    this.initData();
  },
  methods: {
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },

    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.params.checkstate = "";
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getArticleList(params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        // 加载状态结束
        this.loading = false;
      });
    },

    // 筛选状态
    handleState(type, value) {
      if (type == 1) {
        this.params.checkstate = value;
      }
      this.initData();
    },

    // 物流详情
    handleDetail(id) {
      this.encryptstringadd("articleDetail", { id }, "_blank");
    },
    handleEdit(id) {
      this.encryptstringadd("articleEdit", { id }, "_blank");
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params, type) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          if (type != "") {
            window.open(this.$router.resolve({ name, params }).href, "_blank");
          } else {
            this.$router.push({
              name,
              params,
            });
          }
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .screen_wrap {
    font-size: 12px;
    margin-right: 30px;
    .txt {
      cursor: pointer;
      margin-right: 20px;
      &.active {
        font-size: 14px;
        color: red;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .search_wrap {
    width: 280px !important;
  }
  .main_container {
    .select_add {
      p {
        &:last-child {
          margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .detail_icon {
    cursor: pointer;
  }
  .intro_box {
    cursor: pointer;
  }
  .item_main_wrap {
    align-items: center;
    .content_wrap {
      cursor: pointer;
    }
  }
}
</style>